<template>
  <el-row>
    <el-calendar v-model="value">
      <template slot="dateCell" slot-scope="{ date, data }">
        <div
          style="width: 100%; height: 100%; position: relative"
          @click="
            () => {
              createMaintenanceDialogVisible = !createMaintenanceDialogVisible;
              newMaintenanceForm.maintenanceStartDate = date;
            }
          "
        >
          <span>
            {{ data.day.split("-")[2] }}
          </span>
          <div
            style="
              left: 50%;
              top: 50%;
              -webkit-transform: translate(-50%, -50%);
              transform: translate(-50%, -50%);
              position: absolute;
              display: flex;
            "
          >
            <div
              v-for="maintenance in findMaintenancesByDate(date)"
              :key="maintenance.id"
            >
              <div
                :style="{
                  backgroundColor:
                    maintenance.status == 'completed' ? 'green' : 'orange',
                }"
                style="
                  width: 30px;
                  height: 30px;
                  border: 1px solid black;
                  border-radius: 50%;
                "
              ></div>
            </div>
          </div>
        </div>
      </template>
    </el-calendar>

    <el-dialog
      @close="cancelCreateMaintenance"
      :title="$t('maintenance.records')"
      :visible.sync="createMaintenanceDialogVisible"
      width="700px"
      center
    >
      <el-card
        :style="{
          marginBottom: '1rem',
        }"
        v-for="maintenance in findMaintenancesByDate(
          newMaintenanceForm.maintenanceStartDate
        )"
        :key="maintenance.id"
      >
        <el-form label-position="top" label-width="100px">
          <el-form-item>
            <span>{{ $t("maintenance.form.date") }}: </span>
            {{ getFormattedDate(maintenance.maintenanceStartDate) }}
          </el-form-item>
          <el-form-item :label="$t('maintenance.form.title')">
            <el-input readonly="" v-model="maintenance.title"></el-input>
          </el-form-item>
          <el-form-item :label="$t('maintenance.form.description')">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="maintenance.description"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('maintenance.form.status')">
            <div :style="{ display: 'flex', justifyContent: 'space-between' }">
              <div>
                <el-radio v-model="maintenance.status" label="completed">{{
                  $t("maintenance.form.status.completed")
                }}</el-radio>
                <el-radio v-model="maintenance.status" label="continues">{{
                  $t("maintenance.form.status.continues")
                }}</el-radio>
              </div>
              <el-button
                :loading="createMaintenanceButtonLoading"
                type="primary"
                @click="updateMaintenance(maintenance.id)"
                >{{ $t("maintenance.form.update") }}</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-card>

      <el-card
        :style="{
          marginBottom: '1rem',
        }"
      >
        <el-form
          label-position="top"
          label-width="100px"
          :model="newMaintenanceForm"
        >
          <h3 :style="{ textAlign: 'center', fontWeight: 'normal' }">
            {{ $t("maintenance.form.new") }}
          </h3>
          <el-form-item>
            <span>{{ $t("maintenance.form.date") }}: </span>
            {{ getFormattedDate(newMaintenanceForm.maintenanceStartDate) }}
          </el-form-item>
          <el-form-item :label="$t('maintenance.form.title')">
            <el-input v-model="newMaintenanceForm.title"></el-input>
          </el-form-item>
          <el-form-item :label="$t('maintenance.form.description')">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="newMaintenanceForm.description"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('maintenance.form.status')">
            <div :style="{ display: 'flex', justifyContent: 'space-between' }">
              <div>
                <el-radio
                  v-model="newMaintenanceForm.status"
                  label="completed"
                  >{{ $t("maintenance.form.status.completed") }}</el-radio
                >
                <el-radio
                  v-model="newMaintenanceForm.status"
                  label="continues"
                  >{{ $t("maintenance.form.status.continues") }}</el-radio
                >
              </div>
              <el-button
                :loading="createMaintenanceButtonLoading"
                type="primary"
                @click="createMaintenance()"
                >{{ $t("maintenance.form.create") }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item
            width="100%"
            style="display: flex; justify-content: end"
          >
          </el-form-item> </el-form
      ></el-card>
    </el-dialog>
  </el-row>
</template>
  
<script>
import axios from "axios";
export default {
  name: "Maintenance",
  props: ["pointId"],
  data() {
    return {
      createMaintenanceButtonLoading: false,
      newMaintenanceForm: {
        pointId: this.pointId,
        title: "",
        description: "",
        status: "",
        maintenanceStartDate: "",
      },
      value: new Date(),
      createMaintenanceDialogVisible: false,
      maintenances: [],
    };
  },
  created() {
    this.getMaintenances();
  },
  methods: {
    getMaintenances() {
      axios
        .get(
          `${process.env.VUE_APP_APIURL}/maintenances?pointId=${this.pointId}`
        )
        .then((response) => {
          this.maintenances = response.data.map((maintenance) => {
            return {
              id: maintenance._id,
              title: maintenance.title,
              description: maintenance.description,
              status: maintenance.status,
              maintenanceStartDate: maintenance.maintenanceStartDate,
            };
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    findMaintenancesByDate(date) {
      return this.maintenances.filter(
        (maintenance) =>
          this.getFormattedDate(maintenance.maintenanceStartDate) ==
          this.getFormattedDate(date)
      );
    },
    cancelCreateMaintenance() {
      this.newMaintenanceForm = {
        pointId: this.pointId,
        title: "",
        description: "",
        status: "",
        maintenanceStartDate: "",
      };
      this.createMaintenanceDialogVisible = false;
    },
    getFormattedDate(date) {
      date = new Date(date);
      const year = date.getFullYear();
      const month = (1 + date.getMonth()).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");

      return month + "/" + day + "/" + year;
    },
    createMaintenance() {
      this.createMaintenanceButtonLoading = true;
      axios
        .post(
          `${process.env.VUE_APP_APIURL}/maintenances`,
          this.newMaintenanceForm
        )
        .then((res) => {
          this.$message({
            message: this.$t("maintenance.form.create.success"),
            type: "success",
          });
          this.createMaintenanceDialogVisible = false;

          this.maintenances.push({
            id: res.data._id,
            title: this.newMaintenanceForm.title,
            description: this.newMaintenanceForm.description,
            status: this.newMaintenanceForm.status,
            maintenanceStartDate: this.newMaintenanceForm.maintenanceStartDate,
          });

          this.newMaintenanceForm = {
            pointId: this.pointId,
            title: "",
            description: "",
            status: "",
            maintenanceStartDate: "",
          };
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
        });
      this.createMaintenanceButtonLoading = false;
    },
    updateMaintenance(id) {
      this.createMaintenanceButtonLoading = true;
      const maintenance = this.maintenances.filter(
        (maintenance) => maintenance.id == id
      )[0];

      console.log(id);

      axios
        .put(`${process.env.VUE_APP_APIURL}/maintenances/${id}`, {
          description: maintenance.description,
          status: maintenance.status,
        })
        .then(() => {
          this.$message({
            message: this.$t("maintenance.form.update.success"),
            type: "success",
          });
          this.createMaintenanceDialogVisible = false;
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
        });
      this.createMaintenanceButtonLoading = false;
    },
  },
};
</script>
  
<style scoped>
.el-input {
  width: 100%;
}

.maintenance {
  color: #fff;
  background-color: green;
}
</style>